import React from 'react'

import style from './style.css'

export default props => {
    
    return (
        <a
            onClick={props.onClick || null}
            href={props.href || null}
            className={`${style.link} ${style[props.styleType] || style.orange} ${props.className || ''}`}
            target={props.target || ''}
            style={{
                    ...props.style,
                    fontSize: props.size || '14px',
                    width: (props.full) ? '100%' : null
                }}
        >
            {props.children}
        </a>
    )
}


// WEBPACK FOOTER //
// ./src/components/atoms/Link/index.js